//我们会将所有mutations的函数名放在这个文件里
export const SET_USERINFO = "SET_USERINFO";
export const SET_ISLOADING = "SET_ISLOADING";
export const SET_TOKEN = "SET_TOKEN";
export const SET_CARTITEMDATA = "SET_CARTITEMDATA";
export const SET_SHOWLOGINMODEL = "SET_SHOWLOGINMODEL";
export const SET_AUCTIONRECORDITEM = "SET_AUCTIONRECORDITEM";
